import api from './api';

/**
 * Funções auxiliares para formatação
 */
export const formatCurrency = (value) => {
  if (value === null || value === undefined) return 'R$ 0,00';
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
};

export const formatDate = (date) => {
  if (!date) return '-';
  return new Date(date).toLocaleDateString('pt-BR');
};

export const formatDateTime = (date) => {
  if (!date) return '-';
  return new Date(date).toLocaleString('pt-BR');
};

/**
 * Tratamento de erros padronizado
 */
export const handleApiError = (error, defaultMessage = 'Erro ao processar requisição') => {
  console.error('API Error:', error);
  
  if (error.response) {
    // Erro da API
    return error.response.data?.detail || error.response.data?.message || defaultMessage;
  } else if (error.request) {
    // Sem resposta do servidor
    return 'Erro de conexão. Verifique sua internet.';
  } else {
    // Erro na configuração da requisição
    return error.message || defaultMessage;
  }
};

/**
 * Service base com métodos CRUD genéricos
 */
class BaseFinancialService {
  constructor(endpoint) {
    // Endpoint SEM trailing slash para consistência
    this.endpoint = endpoint.endsWith('/') ? endpoint.slice(0, -1) : endpoint;
  }

  async getAll(params = {}) {
    try {
      // ADICIONAR / no final para evitar redirect do FastAPI
      const response = await api.get(`${this.endpoint}/`, { params });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar dados');
    }
  }

  async getById(id) {
    try {
      const response = await api.get(`${this.endpoint}/${id}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao buscar registro');
    }
  }

  async create(data) {
    try {
      const response = await api.post(this.endpoint, data);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao criar registro');
    }
  }

  async update(id, data) {
    try {
      const response = await api.put(`${this.endpoint}/${id}`, data);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao atualizar registro');
    }
  }

  async delete(id) {
    try {
      const response = await api.delete(`${this.endpoint}/${id}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Erro ao deletar registro');
    }
  }
}

export default BaseFinancialService;
